var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookRounded = function SvgFacebookRounded(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 0.959961C4.11196 0.959961 0.959961 4.11196 0.959961 7.99996C0.959961 11.5296 3.55996 14.4438 6.9478 14.9529V9.86588H5.20604V8.01532H6.9478V6.78396C6.9478 4.74524 7.94108 3.8502 9.63548 3.8502C10.447 3.8502 10.8761 3.91036 11.0793 3.93788V5.55324H9.92348C9.20412 5.55324 8.95292 6.23516 8.95292 7.0038V8.01532H11.0611L10.775 9.86588H8.95292V14.968C12.3891 14.5017 15.04 11.5638 15.04 7.99996C15.04 4.11196 11.888 0.959961 7.99996 0.959961Z",
    fill: "#808080"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookRounded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebookRounded.f13ce3c5.svg";
export { ForwardRef as ReactComponent };